"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var Observable_1 = require("rxjs/Observable");
var ReplaySubject_1 = require("rxjs/ReplaySubject");
require("rxjs/add/observable/combineLatest");
var idm_classifier_service_client_js_1 = require("@synisys/idm-classifier-service-client-js");
var idm_de_core_frontend_1 = require("@synisys/idm-de-core-frontend");
var idm_dynamic_controls_metadata_1 = require("@synisys/idm-dynamic-controls-metadata");
var idm_kb_service_client_js_1 = require("@synisys/idm-kb-service-client-js");
var idm_message_language_service_client_js_1 = require("@synisys/idm-message-language-service-client-js");
var idm_session_data_provider_api_js_1 = require("@synisys/idm-session-data-provider-api-js");
var lodash_1 = require("lodash");
var idm_de_core_frontend_2 = require("@synisys/idm-de-core-frontend");
var Subject_1 = require("rxjs/Subject");
var metafield_wrapper_1 = require("../../model/metafield.wrapper");
var portfolio_filter_dto_1 = require("../../model/portfolio-filter-dto");
var date_range_model_1 = require("../../simple/sis-date-range/date-range-model");
var sis_portfolio_accounting_model_1 = require("../../simple/sis-accounting/sis-portfolio-accounting-model");
var parent_filter_dto_1 = require("../../model/parent-filter-dto");
var operators_1 = require("rxjs/operators");
var idm_workflow_service_client_js_1 = require("@synisys/idm-workflow-service-client-js");
var property_value_accessor_model_1 = require("@synisys/idm-de-core-frontend/src/shared/impl/model/property-value-accessor.model");
/**
 *
 */
var FilterComponent = /** @class */ (function () {
    function FilterComponent(kbService, classifierService, languageService, stateService, currentLanguageProvider, messageService) {
        this.kbService = kbService;
        this.classifierService = classifierService;
        this.languageService = languageService;
        this.stateService = stateService;
        this.currentLanguageProvider = currentLanguageProvider;
        this.messageService = messageService;
        this.isLoadedSubject = new ReplaySubject_1.ReplaySubject();
        this.categoryCachable = new Map();
        // Expose enums to use in template.
        this.metaFieldType = idm_kb_service_client_js_1.MetaFieldType;
        /**
             * Key to publish filter by {@link DynamicCommunicationService}.
             * @type {string}
             */
        this.filterWithData = {};
        this.getFilter = new core_1.EventEmitter();
        /**
             * Map, containing Values for combo-box's.
             * Key is {@link MetaField}'s systemName.
             * Value is {@link Array<ClassifierView>}.
             * @type {Map<string, Array<ClassifierView>>}
             * @private
             */
        this._classifiers = new Map();
        this._initialClassifiers = new Map();
        /**
             *
             * Filtered entitysearch fields
             * @type {Map<string, string[]>}
             * private
             */
        this.filterEntitySearchFields = new Map();
        /**
             * Values of filter.
             * @type {Map<string, any>}
             * @default
             * @private
             */
        this._filterValues = new Map();
        /**
             * Is used to init view after all needed info is loaded.
             * @type {boolean}
             * @default
             * @private
             */
        this._isReady = false;
        /**
             *
             * @type {Map<any, any>}
             * @default
             * @private
             */
        this.systemNameSearchNameMap = new Map();
        /**
             * Map to keep provided subentities with its classifier map with sortId for filter
             * key is subentityMetaField, values is its classifiers map
             * @type {Map}
             */
        this.subEntityClassifierNames = new Map();
        /**
             * Map, keeps category systemName as key and it's metaFields list as value.
             * @type {Map}
             */
        this.categorySystemNameMetaFieldsMap = new Map();
        /**
             * an array to keep boolean field options
             * @type {Array}
             */
        this._booleanFieldOptions = [];
        this.ngUnsubscribe = new Subject_1.Subject();
        this.classifaiersByCriteriaStore = {};
    }
    FilterComponent_1 = FilterComponent;
    FilterComponent.prototype.isLoaded = function () {
        return this.isLoadedSubject.asObservable().takeUntil(this.ngUnsubscribe);
    };
    FilterComponent.prototype.ngOnInit = function () {
        var _this = this;
        var currentLanguage$ = this.currentLanguageProvider.getCurrentLanguage();
        var inputLanguages$ = this.languageService.getInputLanguages();
        var defaultLanguage$ = this.languageService.getDefaultLanguage();
        var metaFields$ = this.kbService.getMetaFields(this.categorySystemName);
        var hierarchicalCategories$ = this.kbService.getHierarchicalMetaCategoryIds();
        var outerEntityFilterFields = [];
        var outerEntityFilterFieldsMetaFields$ = [];
        this.filterFields.forEach(function (filterField) {
            if (typeof filterField != 'string' && filterField[FilterComponent_1.OUTER_FILTER_KEY]) {
                var outerEntityCategoryName = _this.getCategoryNameFromFilterJson(filterField, FilterComponent_1.OUTER_FILTER_KEY);
                outerEntityFilterFields.push(outerEntityCategoryName);
                outerEntityFilterFieldsMetaFields$.push(_this.kbService.getMetaFields(outerEntityCategoryName));
            }
        });
        var subEntityClassifiersMetaFields = [];
        var subEntityLoadedClassifiersViewsList$ = [];
        Observable_1.Observable.combineLatest.apply(Observable_1.Observable, [inputLanguages$, currentLanguage$, defaultLanguage$, hierarchicalCategories$, metaFields$].concat(outerEntityFilterFieldsMetaFields$)).takeUntil(this.ngUnsubscribe)
            .subscribe(function (data) {
            _this._inputlanguages = data[0];
            _this._currentLanguage = data[1];
            var defaultLanguage = data[2];
            if (_this._inputlanguages.some(function (inputLanguage) { return inputLanguage.getId() === _this._currentLanguage.getId(); })) {
                _this._portfolioLanguageId = _this._currentLanguage.getId();
            }
            else {
                _this._portfolioLanguageId = defaultLanguage.getId();
            }
            var hierarchicalCategories = data[3];
            var categorySystemNameMetaFields = data[4];
            _this.categorySystemNameMetaFieldsMap = _this.collectCategorySystemNameMetaFieldsMap(outerEntityFilterFields, data.splice(5));
            _this.categorySystemNameMetaFieldsMap.set(_this.categorySystemName, categorySystemNameMetaFields);
            _this.filterMetaFieldsBy(categorySystemNameMetaFields, _this.filterFields).subscribe(function (processedFiltersMetaFields) {
                _this._filteredMetaFields = processedFiltersMetaFields;
                if (_this.subEntityClassifierNames.size > 0) {
                    _this.loadSubEntityMetaFields().takeUntil(_this.ngUnsubscribe).subscribe(function (subEntitiesMetaFields) {
                        var i = 0;
                        _this.subEntityClassifierNames.forEach(function (classifiers, metaField) {
                            //TODO @Davit, is it ok to garantee in ordering of iteration???
                            var classifiersMetaFields = subEntitiesMetaFields[i].filter(function (metaField) {
                                return classifiers.has(metaField.getSystemName());
                            });
                            if (!classifiersMetaFields || classifiersMetaFields.length != classifiers.size) {
                                throw new Error("Mentioned classifiers list is not correct " + classifiers.keys().toString());
                            }
                            else {
                                subEntityClassifiersMetaFields.push.apply(subEntityClassifiersMetaFields, classifiersMetaFields);
                                classifiersMetaFields.forEach(function (classifierMetaField) {
                                    _this._filteredMetaFields.push(new metafield_wrapper_1.MetaFieldWrapper(classifierMetaField, _this.categorySystemName, metaField.getSystemName() + "." + classifierMetaField.getSystemName(), false, null, classifiers.get(classifierMetaField.getSystemName())));
                                    if (!_this._classifiers.get(classifierMetaField.getCompoundCategorySystemName())) {
                                        subEntityLoadedClassifiersViewsList$.push(_this.classifierService.loadClassifiersView(classifierMetaField.getCompoundCategorySystemName()));
                                    }
                                });
                            }
                            i++;
                        });
                        Observable_1.Observable.zip.apply(Observable_1.Observable, subEntityLoadedClassifiersViewsList$).takeUntil(_this.ngUnsubscribe).subscribe(function (subEntityLoadedClassifiersViewsList) {
                            for (var i_1 = 0; i_1 < subEntityLoadedClassifiersViewsList.length; i_1++) {
                                _this._classifiers.set(subEntityClassifiersMetaFields[i_1].getSystemName(), subEntityLoadedClassifiersViewsList[i_1]);
                            }
                            _this.after(hierarchicalCategories);
                        });
                    });
                }
                else {
                    _this.after(hierarchicalCategories);
                }
            });
        });
        this.messageService.getMessage("boolean_measure_value_false").take(1).subscribe(function (message) {
            _this._booleanFieldOptions[0] = { selected: false, message: message };
        });
        this.messageService.getMessage("boolean_measure_value_true").take(1).subscribe(function (message) {
            _this._booleanFieldOptions[1] = { selected: true, message: message };
        });
        this.messageService.getMessage("ui_me.placeholder_select_one").take(1).subscribe(function (message) {
            _this._booleanFieldOptions['select'] = message;
        });
    };
    Object.defineProperty(FilterComponent.prototype, "classifiers", {
        get: function () {
            return this._classifiers;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FilterComponent.prototype, "currentLanguage", {
        get: function () {
            return this._currentLanguage;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FilterComponent.prototype, "filterValues", {
        get: function () {
            return this._filterValues;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FilterComponent.prototype, "isReady", {
        get: function () {
            return this._isReady;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FilterComponent.prototype, "inputlanguages", {
        get: function () {
            return this._inputlanguages;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FilterComponent.prototype, "layoutMetaFields", {
        get: function () {
            return this._layoutMetaFields;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FilterComponent.prototype, "booleanFieldOptions", {
        get: function () {
            return this._booleanFieldOptions;
        },
        enumerable: true,
        configurable: true
    });
    FilterComponent.prototype.onEnter = function () {
        this.search();
    };
    FilterComponent.prototype.searchClick = function (field, $event) {
        this.filterValues.set(field.getPathAsMappingKey(), $event);
        this.search();
    };
    FilterComponent.prototype.getStoredClassifier = function (systemName, compoundCategorySystemName) {
        if (this.classifaiersByCriteriaStore[systemName])
            return this.classifaiersByCriteriaStore[systemName];
        this.classifaiersByCriteriaStore[systemName] = this._getClassifierByCriteria.bind(this, compoundCategorySystemName);
        return this.classifaiersByCriteriaStore[systemName];
    };
    FilterComponent.prototype._getClassifierByCriteria = function (compoundCategorySystemName, searchValue, offset, pageItemsCount) {
        var _this = this;
        var filterBuilder = !searchValue ? Observable_1.Observable.of(undefined) : this.getFilterBuilder(searchValue, compoundCategorySystemName);
        return filterBuilder.switchMap(function (builder) {
            // if (this.filterCriteria) {
            //     filterBuilder.and(this.filterCriteria);
            // }
            var filterJson = builder ? builder.buildJson() : undefined;
            var pagingOptions = new idm_de_core_frontend_1.PagingOptions(offset * pageItemsCount, pageItemsCount);
            return _this.classifierService.loadClassifiersViewByPaging(compoundCategorySystemName, filterJson, pagingOptions)
                .map(function (users) {
                return users.map(function (classifierView) {
                    return ({
                        id: classifierView.id,
                        name: classifierView.name
                    });
                });
            });
        });
    };
    FilterComponent.prototype.getFilterBuilder = function (searchValue, compoundCategorySystemName) {
        var _this = this;
        var nameFields = [];
        return this.kbService.getNameMetaFieldIds(compoundCategorySystemName).map(function (a) {
            a.forEach(function (item) { return nameFields.push(item.getSystemName()); });
            return nameFields.reduce(function (builder, name, i) {
                if (i === 0) {
                    return builder.contains(name + '.' + _this.currentLanguage.getId(), searchValue);
                }
                else {
                    return builder.or((new idm_de_core_frontend_1.FilterBuilder()).contains(name + '.' + _this.currentLanguage.getId(), searchValue).build());
                }
            }, (new idm_de_core_frontend_1.FilterBuilder()));
        });
    };
    FilterComponent.prototype.after = function (hierarchicalCategories) {
        var _this = this;
        this._filteredMetaFields.sort(function (a, b) { return a.sortId - b.sortId; });
        this.filteredHierarchicalMetaCategories = this.createFilteredHierarchy(hierarchicalCategories, this._filteredMetaFields);
        this._layoutMetaFields = this.classifyMetaFields(this._filteredMetaFields);
        this.processSearchFields(this._filteredMetaFields);
        if (this.filterWithData['classifiers']) {
            this._classifiers = this.filterWithData['classifiers'];
        }
        this.loadLookupFieldsFrom(this._filteredMetaFields, this.filteredHierarchicalMetaCategories, this.filterWithData['classifiers']);
        this._filteredMetaFields.forEach(function (metaFieldWrapper) {
            if (!_this._filterValues.get(metaFieldWrapper.getPathAsMappingKey())) { // do not empty advancedFilters which has values
                // do not empty advancedFilters which has values
                _this._filterValues.set(metaFieldWrapper.getPathAsMappingKey(), _this.createEmptyValueFor(metaFieldWrapper));
            }
        });
        if (this.filterWithData && this.filterWithData['filterData']) {
            Array.from(this.filterWithData['filterData'].keys()).forEach(function (fieldName) {
                _this._filterValues.set(fieldName, _this.filterWithData['filterData'].get(fieldName));
            });
        }
        var loadedMetaCategories$ = [];
        this._filteredMetaFields.forEach(function (metaFieldWrapper) {
            var categorySystemName = metaFieldWrapper.metaField.getCompoundCategorySystemName();
            if (categorySystemName && !_this.categoryCachable.get(categorySystemName)) {
                loadedMetaCategories$.push(_this.kbService.getMetaCategoryByMetaCategoryId(new idm_kb_service_client_js_1.MetaCategoryId(categorySystemName)));
            }
        });
        Observable_1.Observable.zip.apply(Observable_1.Observable, loadedMetaCategories$).takeUntil(this.ngUnsubscribe).subscribe(function (metaCategory) {
            for (var i = 0; i < metaCategory.length; i++) {
                _this.categoryCachable.set(metaCategory[i].getSystemName(), metaCategory[i].getIsCacheable());
            }
        });
        this._initialClassifiers = new Map(this.classifiers);
        this.isLoadedSubject.next(true);
        this._isReady = true;
    };
    FilterComponent.prototype.loadSubEntityMetaFields = function () {
        var _this = this;
        var subEntitiesMetaFields$ = [];
        this.subEntityClassifierNames.forEach(function (classifiers, metaField) {
            subEntitiesMetaFields$.push(_this.kbService.getMetaFields(metaField.getCompoundCategorySystemName()));
        });
        return Observable_1.Observable.zip.apply(Observable_1.Observable, subEntitiesMetaFields$).map(function (subEntitiesMetaFields) {
            return subEntitiesMetaFields;
        });
    };
    /**
     * Sets value in filter, and resets/loads child classifiers.
     * @param field
     * @param event - value to set in filter.
     */
    /**
         * Sets value in filter, and resets/loads child classifiers.
         * @param field
         * @param event - value to set in filter.
         */
    FilterComponent.prototype.onClassifierChange = /**
         * Sets value in filter, and resets/loads child classifiers.
         * @param field
         * @param event - value to set in filter.
         */
    function (field, event) {
        var systemName = field.getPathAsMappingKey();
        this.filterValues.set(systemName, event);
        this.searchClick(field, event);
        this.resetChildrenOf(systemName);
        if (event !== null) {
            this.loadChildClassifiers(systemName, event);
        }
    };
    FilterComponent.prototype.isFilterValueEmpty = function (filterValue) {
        if (filterValue == null) {
            return true;
        }
        if ((filterValue instanceof date_range_model_1.DateRangeModel) ||
            (filterValue instanceof sis_portfolio_accounting_model_1.PortfolioAccountingModel)) {
            //new types should be added here...
            return filterValue.isEmpty();
        }
        if (filterValue instanceof Array) {
            return filterValue.length === 0;
        }
        if (!!filterValue === filterValue) { // check for boolean fields
            // check for boolean fields
            return false;
        }
        else {
            return filterValue == "";
        }
    };
    FilterComponent.prototype.search = function () {
        var _this = this;
        var notEmptyValues = new Map();
        this.filterValues.forEach(function (value, key) {
            if (!_this.isFilterValueEmpty(value)) {
                notEmptyValues.set(key, value);
            }
        });
        this.getFilter.emit(notEmptyValues);
    };
    /**
     * Resets Filter values.
     */
    /**
         * Resets Filter values.
         */
    FilterComponent.prototype.reset = /**
         * Resets Filter values.
         */
    function () {
        var _this = this;
        this.initEmptyValueMap();
        this.filteredHierarchicalMetaCategories.forEach(function (field) {
            _this.resetBranchCategories(field);
        });
        this.getFilter.emit(new Map());
    };
    FilterComponent.prototype.getBooleanFieldValue = function (fieldSystemName) {
        return this._filterValues.get(fieldSystemName);
    };
    FilterComponent.prototype.isOutOfHierarchy = function (metaFieldWrapper) {
        return this.filteredHierarchicalMetaCategories.some(function (hierarchicalMetaCategory) {
            return hierarchicalMetaCategory.getSystemName() ===
                metaFieldWrapper.metaField.getCompoundCategorySystemName() &&
                hierarchicalMetaCategory.getChildren().length === 0;
        });
    };
    /**
     * Built filterCriteria AND DRAWS new values to HTML
     * @param filterValues
     */
    /**
         * Built filterCriteria AND DRAWS new values to HTML
         * @param filterValues
         */
    FilterComponent.prototype.buildFilterCriteriaFromOriginalFilters = /**
         * Built filterCriteria AND DRAWS new values to HTML
         * @param filterValues
         */
    function (filterValues) {
        var _this = this;
        //TODO @Torpedo, optimize this method
        this.initEmptyValueMap();
        this._filteredMetaFields.forEach(function (metaFieldWrapper) {
            if (metaFieldWrapper.isParentFilter) {
                var convertedModel = _this.convertObjectToModelIfNotEmpty(metaFieldWrapper, filterValues.get(metaFieldWrapper.getPathAsMappingKey()));
                if (convertedModel) {
                    if (filterValues.get(metaFieldWrapper.getPathAsMappingKey())) {
                        _this._filterValues.set(metaFieldWrapper.getPathAsMappingKey(), convertedModel);
                    }
                }
            }
            else {
                var convertedModel = _this.convertObjectToModelIfNotEmpty(metaFieldWrapper, filterValues.get(_this.categorySystemName + "." + metaFieldWrapper.path));
                if (convertedModel || !!convertedModel === convertedModel) {
                    //	if (filterValues.get(this.categorySystemName + "." + metaFieldWrapper.path)) {
                    //	if (filterValues.get(this.categorySystemName + "." + metaFieldWrapper.path)) {
                    _this._filterValues.set(metaFieldWrapper.getPathAsMappingKey(), convertedModel);
                    //	}
                }
            }
        });
        return this.createFilterFrom(this._filterValues);
    };
    /**
     * Creates filter using {@link FilterBuilder}.
     * @param {Map<string, string>} fieldsMapping - systemName-searchName map.
     * @param {Map<string, any>} filterValues - values for filter.
     * @returns {object}
     * @private
     */
    /**
         * Creates filter using {@link FilterBuilder}.
         * @param {Map<string, string>} fieldsMapping - systemName-searchName map.
         * @param {Map<string, any>} filterValues - values for filter.
         * @returns {object}
         * @private
         */
    FilterComponent.prototype.createFilterFrom = /**
         * Creates filter using {@link FilterBuilder}.
         * @param {Map<string, string>} fieldsMapping - systemName-searchName map.
         * @param {Map<string, any>} filterValues - values for filter.
         * @returns {object}
         * @private
         */
    function (filterValues) {
        var _this = this;
        var fieldsMapping = this.systemNameSearchNameMap;
        var ownFilters = undefined;
        var parentFilters = [];
        Array.from(fieldsMapping.keys()).forEach(function (systemName) {
            var metaFieldWrapper = _this.findMetaFieldWithSystemName(systemName, _this._filteredMetaFields);
            if (!_this.isFilterValueEmpty(filterValues.get(metaFieldWrapper.getPathAsMappingKey()))) {
                if (metaFieldWrapper.isParentFilter) {
                    var parentCategorySystemName = metaFieldWrapper.categorySystemName;
                    var fieldSystemNameInParentEntity = metaFieldWrapper.fieldSystemNameInParentCategory;
                    var parentFilterBuilder = _this.createFilter(metaFieldWrapper, metaFieldWrapper.getPathAsMappingKey(), filterValues, fieldsMapping);
                    if (!parentFilterBuilder) {
                        parentFilterBuilder = new idm_de_core_frontend_1.FilterBuilder();
                    }
                    parentFilters.push(new parent_filter_dto_1.ParentFilterDto(parentFilterBuilder.build(), parentCategorySystemName, fieldSystemNameInParentEntity));
                }
                else {
                    var ownFilterBuilder = _this.createFilter(metaFieldWrapper, metaFieldWrapper.getPathAsMappingKey(), filterValues, fieldsMapping);
                    if (ownFilterBuilder != null) {
                        if (ownFilters == undefined) {
                            ownFilters = new idm_de_core_frontend_1.FilterBuilder();
                        }
                        ownFilters.and(ownFilterBuilder.build());
                    }
                }
            }
        });
        return new portfolio_filter_dto_1.PortfolioFilterDto(ownFilters ? ownFilters.build() : null, parentFilters);
    };
    FilterComponent.prototype.createFilter = function (metaFieldWrapper, systemName, filterValues, fieldMap) {
        var filterBuilder = null;
        var filterCriteria = [];
        switch (metaFieldWrapper.metaField.getType()) {
            case idm_kb_service_client_js_1.MetaFieldType.MULTILINGUAL_STRING: {
                var value = this.extractValueFrom(filterValues.get(systemName));
                if (value !== null) {
                    filterCriteria.push(this.createFilterForText(fieldMap.get(systemName) + "." + this._portfolioLanguageId, value).build());
                }
                break;
            }
            case idm_kb_service_client_js_1.MetaFieldType.ACCOUNTING: {
                var accountingModel = filterValues.get(systemName);
                if (accountingModel.currencyId && (accountingModel.from === 0 || accountingModel.to === 0 || accountingModel.from || accountingModel.to)) { //if both values are not provide, don't do anything
                    //if both values are not provide, don't do anything
                    var fieldName = fieldMap.get(systemName) + ".currencyMoney." + accountingModel.currencyId;
                    var filter = this.createFilterForAccounting(fieldName, accountingModel.from, accountingModel.to);
                    filterCriteria.push(filter.build());
                }
                break;
            }
            case idm_kb_service_client_js_1.MetaFieldType.DATE:
            case idm_kb_service_client_js_1.MetaFieldType.LOCAL_DATE: {
                var from = filterValues.get(systemName).from;
                var to = filterValues.get(systemName).to;
                if (from || to) { //if both values are not provide, don't do anything
                    //if both values are not provide, don't do anything
                    var filter = this.createFilterForDate(fieldMap.get(systemName), from, to);
                    filterCriteria.push(filter.build());
                }
                break;
            }
            case idm_kb_service_client_js_1.MetaFieldType.DATE_TIME:
            case idm_kb_service_client_js_1.MetaFieldType.LOCAL_DATE_TIME: {
                var from = filterValues.get(systemName).from;
                var to = filterValues.get(systemName).to;
                if (from || to) { //if both values are not provide, don't do anything
                    //if both values are not provide, don't do anything
                    var filter = this.createFilterForDateTime(fieldMap.get(systemName), from, to);
                    filterCriteria.push(filter.build());
                }
                break;
            }
            case idm_kb_service_client_js_1.MetaFieldType.STRING: {
                var value = this.extractValueFrom(filterValues.get(systemName));
                if (value !== null) {
                    filterCriteria.push(this.createFilterForText(fieldMap.get(systemName), value).build());
                }
                break;
            }
            case idm_kb_service_client_js_1.MetaFieldType.BOOLEAN: {
                var value = filterValues.get(systemName);
                if (value !== null && value !== undefined) {
                    filterCriteria.push(new idm_de_core_frontend_2.IsFilterCriteria(fieldMap.get(systemName), idm_de_core_frontend_2.FilterOperator.IS, value));
                }
                break;
            }
            default: {
                var value = this.extractValueFrom(filterValues.get(systemName));
                if (value !== null && value !== undefined) {
                    if (lodash_1.isArray(value)) {
                        if (value.length !== 0) {
                            if (!this.categoryCachable.get(metaFieldWrapper.metaField.getCompoundCategorySystemName())) {
                                filterCriteria.push(new idm_de_core_frontend_2.InFilterCriteria(fieldMap.get(systemName), idm_de_core_frontend_2.FilterOperator.IN, filterValues.get(systemName).map(function (e) { return typeof e === 'object' ? e.id : e; })));
                            }
                            else {
                                filterCriteria.push(new idm_de_core_frontend_2.InFilterCriteria(fieldMap.get(systemName), idm_de_core_frontend_2.FilterOperator.IN, value));
                            }
                        }
                    }
                    else {
                        filterCriteria.push(new idm_de_core_frontend_2.IsFilterCriteria(fieldMap.get(systemName), idm_de_core_frontend_2.FilterOperator.IS, value));
                    }
                }
            }
        }
        if (filterCriteria.length > 0) {
            filterBuilder = new idm_de_core_frontend_1.FilterBuilder();
            filterCriteria.forEach(function (filterCriteria) {
                filterBuilder.and(filterCriteria);
            });
        }
        return filterBuilder;
    };
    FilterComponent.prototype.createFilterForText = function (searchName, searchValue) {
        var filter = new idm_de_core_frontend_1.FilterBuilder();
        filter.contains(searchName, "" + searchValue).build();
        return filter;
    };
    FilterComponent.prototype.createFilterForAccounting = function (fieldSystemName, startDataValue, endDateValue) {
        var filter = new idm_de_core_frontend_1.FilterBuilder();
        if (startDataValue === 0 || startDataValue) {
            filter.gte(fieldSystemName, startDataValue);
        }
        if (endDateValue === 0 || endDateValue) {
            filter.lte(fieldSystemName, endDateValue);
        }
        return filter;
    };
    FilterComponent.prototype.createFilterForDate = function (fieldSystemName, startDataValue, endDateValue) {
        var filter = new idm_de_core_frontend_1.FilterBuilder();
        if (startDataValue) {
            filter.gte(fieldSystemName, startDataValue);
        }
        if (endDateValue) {
            filter.lte(fieldSystemName, endDateValue);
        }
        return filter;
    };
    FilterComponent.prototype.createFilterForDateTime = function (fieldSystemName, startDataValue, endDateValue) {
        var filter = new idm_de_core_frontend_1.FilterBuilder();
        var timezoneOffsetInMilliseconds = new Date().getTimezoneOffset() * 60 * 1000;
        if (startDataValue) {
            filter.gte(fieldSystemName, startDataValue + timezoneOffsetInMilliseconds);
        }
        if (endDateValue) {
            // a day in milliseconds
            var day = 60 * 60 * 24 * 1000;
            //to include whole end date till 23:59:59 in filter
            filter.lt(fieldSystemName, endDateValue + day + timezoneOffsetInMilliseconds);
        }
        return filter;
    };
    /**
     * Filters CategoryHierarchy from given Hierarchy and MetaFields.
     * @param {Array<HierarchicalMetaCategoryId>} metaCategories - hierarchy of categories to filter.
     * @param {Array<MetaField>} metaFieldWrappers - metaFields to filter with.
     * @returns {Array<HierarchicalMetaCategoryId>} - filtered Hierarchy.
     * @private
     */
    /**
         * Filters CategoryHierarchy from given Hierarchy and MetaFields.
         * @param {Array<HierarchicalMetaCategoryId>} metaCategories - hierarchy of categories to filter.
         * @param {Array<MetaField>} metaFieldWrappers - metaFields to filter with.
         * @returns {Array<HierarchicalMetaCategoryId>} - filtered Hierarchy.
         * @private
         */
    FilterComponent.prototype.createFilteredHierarchy = /**
         * Filters CategoryHierarchy from given Hierarchy and MetaFields.
         * @param {Array<HierarchicalMetaCategoryId>} metaCategories - hierarchy of categories to filter.
         * @param {Array<MetaField>} metaFieldWrappers - metaFields to filter with.
         * @returns {Array<HierarchicalMetaCategoryId>} - filtered Hierarchy.
         * @private
         */
    function (metaCategories, metaFieldWrappers) {
        var _this = this;
        var filteredMetaCategoryHierarchy = [];
        metaCategories.forEach(function (category) {
            var metaField = _this.findMetaFieldWithCompoundCategorySystemName(category.getSystemName(), metaFieldWrappers);
            if (metaField === undefined) {
                filteredMetaCategoryHierarchy.push.apply(filteredMetaCategoryHierarchy, _this.createFilteredHierarchy(category.getChildren(), metaFieldWrappers));
            }
            else {
                var currentHierarchy = new idm_kb_service_client_js_1.HierarchicalMetaCategoryId(category.getSystemName(), category.getIsRoot(), _this.createFilteredHierarchy(category.getChildren(), metaFieldWrappers));
                filteredMetaCategoryHierarchy.push(currentHierarchy);
            }
        });
        return filteredMetaCategoryHierarchy;
    };
    /**
     * Loads first depth lookup fields.
     * Depth is determined from {@param categories}.
     * @param {Array<MetaField>} metaFieldWrappers - metaFields to load fields from.
     * @returns {Map<string, Array<ClassifierView>>}
     * @private
     */
    /**
         * Loads first depth lookup fields.
         * Depth is determined from {@param categories}.
         * @param {Array<MetaField>} metaFieldWrappers - metaFields to load fields from.
         * @returns {Map<string, Array<ClassifierView>>}
         * @private
         */
    FilterComponent.prototype.loadLookupFieldsFrom = /**
         * Loads first depth lookup fields.
         * Depth is determined from {@param categories}.
         * @param {Array<MetaField>} metaFieldWrappers - metaFields to load fields from.
         * @returns {Map<string, Array<ClassifierView>>}
         * @private
         */
    function (metaFieldWrappers, categories, filterWithData) {
        var _this = this;
        if (filterWithData === void 0) { filterWithData = new Map(); }
        metaFieldWrappers
            .filter(function (metaFieldWrapper) {
            return (metaFieldWrapper.metaField.getType() === idm_kb_service_client_js_1.MetaFieldType.WORKFLOW_STATE || metaFieldWrapper.metaField.getType() === idm_kb_service_client_js_1.MetaFieldType.CLASSIFIER || metaFieldWrapper.metaField.getType() === idm_kb_service_client_js_1.MetaFieldType.MULTI_SELECT) &&
                !filterWithData.has(metaFieldWrapper.metaField.getSystemName());
        })
            .forEach(function (metaFieldWrapper) {
            var metaCategory = categories.find(function (category) {
                return category.getSystemName() === metaFieldWrapper.metaField.getCompoundCategorySystemName();
            });
            if (metaCategory === undefined) {
                _this._classifiers.set(metaFieldWrapper.metaField.getSystemName(), []);
            }
            else if (metaFieldWrapper.metaField.getType() === idm_kb_service_client_js_1.MetaFieldType.WORKFLOW_STATE) {
                _this.kbService.getMetaCategoryByMetaCategoryId(new idm_kb_service_client_js_1.MetaCategoryId(_this.categorySystemName)).pipe(operators_1.switchMap(function (category) { return _this.stateService.getStates(category.getWFProcessId()); })).subscribe(function (views) {
                    var classifier = views.map(function (view) {
                        var map = new Map();
                        map.set("id", new property_value_accessor_model_1.PropertyValueAccessor(view.getId()));
                        map.set("name", new property_value_accessor_model_1.PropertyValueAccessor(view.getName().getValue(_this.currentLanguage.getId())));
                        return new idm_classifier_service_client_js_1.ClassifierView(map);
                    });
                    _this._classifiers.set(metaFieldWrapper.metaField.getSystemName(), classifier);
                });
            }
            else {
                _this.classifierService.loadClassifiersView(metaFieldWrapper.metaField.getCompoundCategorySystemName())
                    .takeUntil(_this.ngUnsubscribe)
                    .subscribe(function (views) {
                    _this._classifiers.set(metaFieldWrapper.metaField.getSystemName(), views);
                });
            }
        });
    };
    /**
     * Loads child classifiers for given systemName.
     * Sets them in {@link _classifiers}.
     * @param {string} systemName - {@link MetaField}s systemName.
     * @param {number} parentId - id of parent to load children with.
     * @private
     */
    /**
         * Loads child classifiers for given systemName.
         * Sets them in {@link _classifiers}.
         * @param {string} systemName - {@link MetaField}s systemName.
         * @param {number} parentId - id of parent to load children with.
         * @private
         */
    FilterComponent.prototype.loadChildClassifiers = /**
         * Loads child classifiers for given systemName.
         * Sets them in {@link _classifiers}.
         * @param {string} systemName - {@link MetaField}s systemName.
         * @param {number} parentId - id of parent to load children with.
         * @private
         */
    function (systemName, parentId) {
        var _this = this;
        var metaField = this.findMetaFieldWithSystemName(systemName, this._filteredMetaFields);
        this.getBranchFor(metaField, this.filteredHierarchicalMetaCategories)
            .getChildren()
            .forEach(function (child) {
            _this.classifierService
                .loadClassifiersViewByParent(child.getSystemName(), parentId)
                .takeUntil(_this.ngUnsubscribe)
                .subscribe(function (children) {
                var field = _this.findMetaFieldWithCompoundCategorySystemName(child.getSystemName(), _this._filteredMetaFields);
                _this._classifiers.set(field.metaField.getSystemName(), children.length > 0 ? children : []);
                return children;
            });
        });
    };
    /**
     * Filters {@link MetaField}s by systemName.
     * @param {Array<MetaField>} metaFields - array to filter from.
     * @param {Array<string>} filterFields - systemNames to filter with.
     * @returns {Array<MetaField>}
     * @private
     */
    /**
         * Filters {@link MetaField}s by systemName.
         * @param {Array<MetaField>} metaFields - array to filter from.
         * @param {Array<string>} filterFields - systemNames to filter with.
         * @returns {Array<MetaField>}
         * @private
         */
    FilterComponent.prototype.filterMetaFieldsBy = /**
         * Filters {@link MetaField}s by systemName.
         * @param {Array<MetaField>} metaFields - array to filter from.
         * @param {Array<string>} filterFields - systemNames to filter with.
         * @returns {Array<MetaField>}
         * @private
         */
    function (metaFields, filterFields) {
        var _this = this;
        var metaFieldWrappers = new Map();
        metaFields.map(function (metaField) {
            //at first change MetaField to MetaFieldWrapper object
            metaFieldWrappers.set(metaField.getSystemName(), new metafield_wrapper_1.MetaFieldWrapper(metaField, _this.categorySystemName, metaField.getSystemName(), false, null));
        });
        var processedFilterFields = [];
        for (var j = 0; j < filterFields.length; j++) {
            processedFilterFields.push(this.processFilterFields(filterFields[j], metaFieldWrappers, j));
        }
        return Observable_1.Observable.zip.apply(Observable_1.Observable, processedFilterFields).mergeMap(function (fields) {
            var processedFilterFields = [];
            fields.forEach(function (field) {
                processedFilterFields.push.apply(processedFilterFields, field);
            });
            return Observable_1.Observable.of(processedFilterFields);
        });
    };
    FilterComponent.prototype.processFilterFields = function (filterField, metaFieldWrappers, sortId) {
        if (typeof filterField === 'string') {
            if (filterField.indexOf(".") > 0) { //case of sub-entity
                //case of sub-entity
                return this.findChildMetaField(filterField.toString(), metaFieldWrappers, sortId);
                // this._filteredMetaFields.push(new MetaFieldWrapper(classifierMetaField, this.categorySystemName, metaField.getSystemName() + "." + classifierMetaField.getSystemName(), false));
            }
            else { //case of standard field of provided entity
                //case of standard field of provided entity
                var metaField = metaFieldWrappers.get(filterField);
                if (metaField === undefined) {
                    throw Error("Cannot find field with " + filterField + " systemName.");
                }
                metaField.sortId = sortId;
                return Observable_1.Observable.of(new Array(metaField));
            }
        }
        else { //case of main-entity and parent-entity
            //case of main-entity and parent-entity
            if (filterField[FilterComponent_1.OUTER_FILTER_KEY] && filterField[FilterComponent_1.OUTER_FILTER_KEY] == true) { //case of parent-entity
                //case of parent-entity
                return Observable_1.Observable.of(this.collectOuterFilterMetaFieldWrappers(filterField, sortId));
            }
            else if ((filterField[FilterComponent_1.INNER_FILTER_KEY] && filterField[FilterComponent_1.INNER_FILTER_KEY] == true) ||
                !filterField[FilterComponent_1.INNER_FILTER_KEY]) { //case of main-entity
                //case of main-entity
                var innerFilterCategoryField = this.getCategoryNameFromFilterJson(filterField, FilterComponent_1.INNER_FILTER_KEY);
                this.filterEntitySearchFields.set(innerFilterCategoryField, filterField[innerFilterCategoryField]);
                var metaFieldWrapper = metaFieldWrappers.get(innerFilterCategoryField);
                metaFieldWrapper.sortId = sortId;
                return Observable_1.Observable.of(new Array(metaFieldWrapper));
            }
        }
    };
    /**
     * Returns exact filter field properties from provided filterFields json.
     * @param filterFieldObj                FilterField json definition. [e.g. {'isInner':true, 'PROJECT':['Name', 'RecordNo']}]
     * @param exceptKey                     Filter type flag in json property [e.g. 'isInner']
     * @returns {any}                       Exact filter properties.
     */
    /**
         * Returns exact filter field properties from provided filterFields json.
         * @param filterFieldObj                FilterField json definition. [e.g. {'isInner':true, 'PROJECT':['Name', 'RecordNo']}]
         * @param exceptKey                     Filter type flag in json property [e.g. 'isInner']
         * @returns {any}                       Exact filter properties.
         */
    FilterComponent.prototype.getCategoryNameFromFilterJson = /**
         * Returns exact filter field properties from provided filterFields json.
         * @param filterFieldObj                FilterField json definition. [e.g. {'isInner':true, 'PROJECT':['Name', 'RecordNo']}]
         * @param exceptKey                     Filter type flag in json property [e.g. 'isInner']
         * @returns {any}                       Exact filter properties.
         */
    function (filterFieldObj, exceptKey) {
        return Object.keys(filterFieldObj).find(function (key) {
            return key != exceptKey;
        });
    };
    /**
     * Collect all sub-entities with its classifiers list
     * @param filterFieldSystemNameValue
     * @param metaFieldWrappers
     * @param sortId
     */
    /**
         * Collect all sub-entities with its classifiers list
         * @param filterFieldSystemNameValue
         * @param metaFieldWrappers
         * @param sortId
         */
    FilterComponent.prototype.findChildMetaField = /**
         * Collect all sub-entities with its classifiers list
         * @param filterFieldSystemNameValue
         * @param metaFieldWrappers
         * @param sortId
         */
    function (filterFieldSystemNameValue, metaFieldWrappers, sortId) {
        var _this = this;
        var subEntityName = filterFieldSystemNameValue.substring(0, filterFieldSystemNameValue.indexOf("."));
        var subEntityMetaFieldWrapper = metaFieldWrappers.get(subEntityName);
        if (subEntityMetaFieldWrapper && subEntityMetaFieldWrapper.metaField.getType() == idm_kb_service_client_js_1.MetaFieldType.SUB_ENTITY) {
            var subEntityChildFieldName_1 = filterFieldSystemNameValue.substring(filterFieldSystemNameValue.indexOf(".") + 1, filterFieldSystemNameValue.length);
            var metaFieldWrapper$ = this.kbService.getMetaFields(subEntityMetaFieldWrapper.metaField.getCompoundCategorySystemName()).mergeMap(function (subEntityFields) {
                var subEntityMetaField = subEntityFields.find(function (subEntityField) { return subEntityField.getSystemName() == subEntityChildFieldName_1; });
                if (!subEntityMetaField) {
                    throw Error("The " + subEntityName + " hasn't " + subEntityChildFieldName_1 + " field.");
                }
                else {
                    var metaFieldWrapper_1 = [];
                    var metaFieldWrapperObservable = Observable_1.Observable.of(null);
                    if (subEntityMetaField.getSystemName() == subEntityChildFieldName_1) {
                        switch (subEntityMetaField.getType()) {
                            //TODO @Torpedo, maybe all fields???
                            case idm_kb_service_client_js_1.MetaFieldType.CLASSIFIER:
                                var subEntityChildMetaField = _this.subEntityClassifierNames.get(subEntityMetaFieldWrapper.metaField);
                                if (!subEntityChildMetaField) {
                                    subEntityChildMetaField = new Map();
                                }
                                subEntityChildMetaField.set(subEntityChildFieldName_1, sortId);
                                _this.subEntityClassifierNames.set(subEntityMetaFieldWrapper.metaField, subEntityChildMetaField);
                                break;
                            case idm_kb_service_client_js_1.MetaFieldType.MAIN_ENTITY:
                                metaFieldWrapper_1.push(new metafield_wrapper_1.MetaFieldWrapper(subEntityMetaField, _this.categorySystemName, filterFieldSystemNameValue, false, null, sortId));
                                metaFieldWrapperObservable = _this.kbService.getNameMetaFieldIds(subEntityMetaField.getCompoundCategorySystemName()).mergeMap(function (nameMeasures) {
                                    var str = [];
                                    nameMeasures.forEach(function (nameMeasure) { return str.push(nameMeasure.getSystemName()); });
                                    _this.filterEntitySearchFields.set(subEntityMetaField.getSystemName(), str);
                                    return metaFieldWrapper_1;
                                });
                        }
                    }
                    return metaFieldWrapperObservable;
                }
            });
            return metaFieldWrapper$.map(function (data) {
                var metaFieldWrappers = [];
                if (data) {
                    metaFieldWrappers.push(data);
                }
                return metaFieldWrappers;
            });
        }
        else {
            throw Error("The " + filterFieldSystemNameValue + " is wrong configured. " + subEntityName + " isn't sub-entity.");
        }
    };
    /**
     * Resets children of given category.
     * @param {string} systemName - systemName of categories {@link MetaField}.
     * @private
     */
    /**
         * Resets children of given category.
         * @param {string} systemName - systemName of categories {@link MetaField}.
         * @private
         */
    FilterComponent.prototype.resetChildrenOf = /**
         * Resets children of given category.
         * @param {string} systemName - systemName of categories {@link MetaField}.
         * @private
         */
    function (systemName) {
        var metaField = this.findMetaFieldWithSystemName(systemName, this._filteredMetaFields);
        this.resetBranchCategories(this.getBranchFor(metaField, this.filteredHierarchicalMetaCategories));
    };
    /**
     * Recursively resets child category values and classifiers of given {@link HierarchicalMetaCategoryId}.
     * @param {HierarchicalMetaCategoryId} category - branch.
     */
    /**
         * Recursively resets child category values and classifiers of given {@link HierarchicalMetaCategoryId}.
         * @param {HierarchicalMetaCategoryId} category - branch.
         */
    FilterComponent.prototype.resetBranchCategories = /**
         * Recursively resets child category values and classifiers of given {@link HierarchicalMetaCategoryId}.
         * @param {HierarchicalMetaCategoryId} category - branch.
         */
    function (category) {
        var _this = this;
        category.getChildren().forEach(function (child) {
            var metaFieldWrapper = _this.findMetaFieldWithCompoundCategorySystemName(child.getSystemName(), _this._filteredMetaFields);
            _this._filterValues.set(metaFieldWrapper.path, null);
            _this._classifiers.set(metaFieldWrapper.metaField.getSystemName(), _this._initialClassifiers.get(metaFieldWrapper.metaField.getSystemName()));
            _this.resetBranchCategories(child);
        });
    };
    /**
     * Returns {@link HierarchicalMetaCategoryId} from {@param hierarchy} by systemName of {@link MetaCategory}.
     * In this cate it is compoundCategorySystemName of {@link MetaField}.
     * @param {MetaField} metaFieldWrapper - metaField, which is root for a hierarchy.
     * @param {Array<HierarchicalMetaCategoryId>} hierarchy - given hierarchy to search in.
     * @returns {HierarchicalMetaCategoryId}
     * @private
     */
    /**
         * Returns {@link HierarchicalMetaCategoryId} from {@param hierarchy} by systemName of {@link MetaCategory}.
         * In this cate it is compoundCategorySystemName of {@link MetaField}.
         * @param {MetaField} metaFieldWrapper - metaField, which is root for a hierarchy.
         * @param {Array<HierarchicalMetaCategoryId>} hierarchy - given hierarchy to search in.
         * @returns {HierarchicalMetaCategoryId}
         * @private
         */
    FilterComponent.prototype.getBranchFor = /**
         * Returns {@link HierarchicalMetaCategoryId} from {@param hierarchy} by systemName of {@link MetaCategory}.
         * In this cate it is compoundCategorySystemName of {@link MetaField}.
         * @param {MetaField} metaFieldWrapper - metaField, which is root for a hierarchy.
         * @param {Array<HierarchicalMetaCategoryId>} hierarchy - given hierarchy to search in.
         * @returns {HierarchicalMetaCategoryId}
         * @private
         */
    function (metaFieldWrapper, hierarchy) {
        var _this = this;
        var branch = null;
        hierarchy.some(function (category) {
            if (category.getSystemName() === metaFieldWrapper.metaField.getCompoundCategorySystemName()) {
                branch = category;
                return true;
            }
            else if (category.getChildren().length > 0) {
                branch = _this.getBranchFor(metaFieldWrapper, category.getChildren());
                return branch !== null;
            }
        });
        return branch;
    };
    /**
     * Extracts value from given value with some logic.
     * @param item - given value
     * @returns {string | number} - extracted value.
     * @private
     */
    /**
         * Extracts value from given value with some logic.
         * @param item - given value
         * @returns {string | number} - extracted value.
         * @private
         */
    FilterComponent.prototype.extractValueFrom = /**
         * Extracts value from given value with some logic.
         * @param item - given value
         * @returns {string | number} - extracted value.
         * @private
         */
    function (item) {
        if (item instanceof idm_classifier_service_client_js_1.ClassifierView) {
            return item.id;
        }
        else if (typeof item === 'string') {
            return item.trim() === '' ? null : item.trim();
        }
        else {
            return item;
        }
    };
    /**
     * Initializes map with empty values.
     * Empty values are determined with {@link createEmptyValueFor} function.
     * @private
     */
    /**
         * Initializes map with empty values.
         * Empty values are determined with {@link createEmptyValueFor} function.
         * @private
         */
    FilterComponent.prototype.initEmptyValueMap = /**
         * Initializes map with empty values.
         * Empty values are determined with {@link createEmptyValueFor} function.
         * @private
         */
    function () {
        var _this = this;
        this._filteredMetaFields.forEach(function (metaFieldWrapper) {
            _this._filterValues.set(metaFieldWrapper.getPathAsMappingKey(), _this.createEmptyValueFor(metaFieldWrapper));
        });
    };
    /**
     * Creates empty value by {@link MetaFieldWrapper}.
     * @returns {any}
     * @private
     * @param metaFieldWrapper
     */
    /**
         * Creates empty value by {@link MetaFieldWrapper}.
         * @returns {any}
         * @private
         * @param metaFieldWrapper
         */
    FilterComponent.prototype.createEmptyValueFor = /**
         * Creates empty value by {@link MetaFieldWrapper}.
         * @returns {any}
         * @private
         * @param metaFieldWrapper
         */
    function (metaFieldWrapper) {
        switch (metaFieldWrapper.metaField.getType()) {
            case idm_kb_service_client_js_1.MetaFieldType.MAIN_ENTITY: {
                return [];
            }
            case idm_kb_service_client_js_1.MetaFieldType.DATE:
            case idm_kb_service_client_js_1.MetaFieldType.DATE_TIME:
            case idm_kb_service_client_js_1.MetaFieldType.LOCAL_DATE_TIME:
            case idm_kb_service_client_js_1.MetaFieldType.LOCAL_DATE: {
                return new date_range_model_1.DateRangeModel(undefined, undefined);
            }
            case idm_kb_service_client_js_1.MetaFieldType.ACCOUNTING: {
                return new sis_portfolio_accounting_model_1.PortfolioAccountingModel(undefined, undefined, undefined);
            }
            default:
                return null;
        }
    };
    /**
     * Returns {@link MetaField} with matching systemName.
     * @param systemNameValue - systemName of searched {@link MetaField}.
     * @param {Array<MetaField>} metaFieldWrappers - array to search in.
     * @returns {MetaField}
     * @private
     */
    /**
         * Returns {@link MetaField} with matching systemName.
         * @param systemNameValue - systemName of searched {@link MetaField}.
         * @param {Array<MetaField>} metaFieldWrappers - array to search in.
         * @returns {MetaField}
         * @private
         */
    FilterComponent.prototype.findMetaFieldWithSystemName = /**
         * Returns {@link MetaField} with matching systemName.
         * @param systemNameValue - systemName of searched {@link MetaField}.
         * @param {Array<MetaField>} metaFieldWrappers - array to search in.
         * @returns {MetaField}
         * @private
         */
    function (systemNameValue, metaFieldWrappers) {
        return metaFieldWrappers.find(function (metaFieldWrapper) {
            return metaFieldWrapper.getPathAsMappingKey() === systemNameValue;
        });
    };
    /**
     * Returns {@link MetaField} with matching compoundCategorySystemName.
     * @param {string} systemName - compoundCategorySystemName of searched {@link MetaField}.
     * @param {Array<MetaField>} metaFieldWrappers - array to search in.
     * @returns {MetaField}
     * @private
     */
    /**
         * Returns {@link MetaField} with matching compoundCategorySystemName.
         * @param {string} systemName - compoundCategorySystemName of searched {@link MetaField}.
         * @param {Array<MetaField>} metaFieldWrappers - array to search in.
         * @returns {MetaField}
         * @private
         */
    FilterComponent.prototype.findMetaFieldWithCompoundCategorySystemName = /**
         * Returns {@link MetaField} with matching compoundCategorySystemName.
         * @param {string} systemName - compoundCategorySystemName of searched {@link MetaField}.
         * @param {Array<MetaField>} metaFieldWrappers - array to search in.
         * @returns {MetaField}
         * @private
         */
    function (systemName, metaFieldWrappers) {
        return metaFieldWrappers.find(function (metaFieldWrapper) {
            return metaFieldWrapper.metaField.getCompoundCategorySystemName() === systemName;
        });
    };
    /**
     * Classifies {@link MetaField}s to arrays to draw layout.
     * Dependent fields are generated in new Array.
     * @param {Array<MetaFieldWrapper>} metaFieldWrappers
     * @returns {Array<Array<MetaField>>}
     */
    /**
         * Classifies {@link MetaField}s to arrays to draw layout.
         * Dependent fields are generated in new Array.
         * @param {Array<MetaFieldWrapper>} metaFieldWrappers
         * @returns {Array<Array<MetaField>>}
         */
    FilterComponent.prototype.classifyMetaFields = /**
         * Classifies {@link MetaField}s to arrays to draw layout.
         * Dependent fields are generated in new Array.
         * @param {Array<MetaFieldWrapper>} metaFieldWrappers
         * @returns {Array<Array<MetaField>>}
         */
    function (metaFieldWrappers) {
        var _this = this;
        var classifiedMetaFields = [[]];
        metaFieldWrappers.forEach(function (metaFieldWrapper) {
            var category = _this.filteredHierarchicalMetaCategories.find(function (field) {
                return field.getSystemName() === metaFieldWrapper.metaField.getCompoundCategorySystemName();
            });
            if (category === undefined || category.getChildren().length === 0) {
                classifiedMetaFields[classifiedMetaFields.length - 1].push(metaFieldWrapper);
            }
            else {
                classifiedMetaFields.push([metaFieldWrapper]);
            }
        });
        return classifiedMetaFields;
    };
    FilterComponent.prototype.processSearchFields = function (fields) {
        var _this = this;
        this.systemNameSearchNameMap = new Map();
        fields.forEach(function (field) {
            var mappingKeyForHtmlElements = field.getPathAsMappingKey();
            if (!_this.systemNameSearchNameMap.has(mappingKeyForHtmlElements)) {
                _this.systemNameSearchNameMap.set(mappingKeyForHtmlElements, field.path);
            }
        });
    };
    FilterComponent.prototype.collectCategorySystemNameMetaFieldsMap = function (outerEntityFilterFields, metaFields) {
        var categorySysNameMetaFields = new Map();
        for (var i = 0; i < outerEntityFilterFields.length; i++) {
            categorySysNameMetaFields.set(outerEntityFilterFields[i], metaFields[i]);
        }
        return categorySysNameMetaFields;
    };
    /**
     * Receives outer filter configuration and return corresponding MetaFieldWrapper object
     * @param filterField
     * @param sortId
     */
    /**
         * Receives outer filter configuration and return corresponding MetaFieldWrapper object
         * @param filterField
         * @param sortId
         */
    FilterComponent.prototype.collectOuterFilterMetaFieldWrappers = /**
         * Receives outer filter configuration and return corresponding MetaFieldWrapper object
         * @param filterField
         * @param sortId
         */
    function (filterField, sortId) {
        var outerFilterCategorySystemName = this.getCategoryNameFromFilterJson(filterField, FilterComponent_1.OUTER_FILTER_KEY);
        var outerFilterCategoryFilterFields = filterField[outerFilterCategorySystemName];
        var outerFilterCategoryMetaFields = this.categorySystemNameMetaFieldsMap.get(outerFilterCategorySystemName);
        var metaFieldWrappers = [];
        outerFilterCategoryFilterFields.forEach(function (outerFilterCategoryFilterField) {
            var outerFilterFieldMetaField = outerFilterCategoryMetaFields.find(function (outerFilterCategoryMetaField) {
                return outerFilterCategoryMetaField.getSystemName() == outerFilterCategoryFilterField;
            });
            var fieldSystemNameInParentCategory = filterField['fieldNameInParentCategory'];
            if (outerFilterFieldMetaField && fieldSystemNameInParentCategory) {
                metaFieldWrappers.push(new metafield_wrapper_1.MetaFieldWrapper(outerFilterFieldMetaField, outerFilterCategorySystemName, outerFilterCategoryFilterField, true, fieldSystemNameInParentCategory, sortId));
            }
            else {
                throw new Error("Provided configuration " + filterField + " is wrong.");
            }
        });
        return metaFieldWrappers;
    };
    FilterComponent.prototype.trackByFilterFieldSystemName = function (index, item) {
        return item.metaField.getSystemName();
    };
    FilterComponent.prototype.ngOnDestroy = function () {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    };
    FilterComponent.prototype.convertObjectToModelIfNotEmpty = function (metaFieldWrapper, newValue) {
        if (newValue || !!newValue === newValue) {
            switch (metaFieldWrapper.metaField.getType()) {
                case idm_kb_service_client_js_1.MetaFieldType.MAIN_ENTITY: {
                    return newValue;
                }
                case idm_kb_service_client_js_1.MetaFieldType.DATE:
                case idm_kb_service_client_js_1.MetaFieldType.DATE_TIME:
                case idm_kb_service_client_js_1.MetaFieldType.LOCAL_DATE_TIME:
                case idm_kb_service_client_js_1.MetaFieldType.LOCAL_DATE: {
                    return new date_range_model_1.DateRangeModel(newValue['from'], newValue['to']);
                }
                case idm_kb_service_client_js_1.MetaFieldType.ACCOUNTING: {
                    return new sis_portfolio_accounting_model_1.PortfolioAccountingModel(newValue['from'], newValue['to'], newValue['currencyId']);
                }
                default:
                    return newValue;
            }
        }
        return undefined;
    };
    FilterComponent.INNER_FILTER_KEY = 'isInnerFilter';
    FilterComponent.OUTER_FILTER_KEY = 'isOuterFilter';
    FilterComponent.decorators = [
        { type: core_1.Component, args: [{
                    moduleId: module.id + '',
                    selector: 'sis-portfolio-filter',
                    styles: [require('./filter.component.css')],
                    template: require('./filter.component.html'),
                },] },
    ];
    /** @nocollapse */
    FilterComponent.ctorParameters = function () { return [
        { type: idm_kb_service_client_js_1.KbService, },
        { type: idm_classifier_service_client_js_1.ClassifierService, },
        { type: idm_message_language_service_client_js_1.LanguageService, },
        { type: idm_workflow_service_client_js_1.StateService, },
        { type: idm_session_data_provider_api_js_1.CurrentLanguageProvider, },
        { type: idm_message_language_service_client_js_1.MessageService, },
    ]; };
    FilterComponent.propDecorators = {
        "categorySystemName": [{ type: core_1.Input },],
        "filterFields": [{ type: core_1.Input },],
        "filterWithData": [{ type: core_1.Input },],
        "getFilter": [{ type: core_1.Output },],
        "onEnter": [{ type: core_1.HostListener, args: ['keyup.enter',] },],
    };
    /**
     *
     */
    FilterComponent = FilterComponent_1 = __decorate([
        idm_dynamic_controls_metadata_1.ControlMetadata({
            template: "\n                      <sis-portfolio-filter\n                          [categorySystemName]=\"'%{categorySystemName}'\"\n                          [filterFields]=\"%{filterFields}\"\n                          [filterKey]=\"'%{filterKey}'\"\n                          %{#filterWithData} [filterWithData]=\"%{filterWithData}\"%{/filterWithData}\n                          %{#getFilter} (getFilter)=\"%{getFilter}\"%{/getFilter}\n                          %{#filterWithDataChange} (filterWithDataChange)=\"%{filterWithDataChange}\"%{/filterWithDataChange}>\n                      </sis-portfolio-filter>\n                   ",
        }),
        __metadata("design:paramtypes", [idm_kb_service_client_js_1.KbService,
            idm_classifier_service_client_js_1.ClassifierService,
            idm_message_language_service_client_js_1.LanguageService,
            idm_workflow_service_client_js_1.StateService,
            idm_session_data_provider_api_js_1.CurrentLanguageProvider,
            idm_message_language_service_client_js_1.MessageService])
    ], FilterComponent);
    return FilterComponent;
    var FilterComponent_1;
}());
exports.FilterComponent = FilterComponent;
//# sourceMappingURL=filter.component.js.map